import { Box, makeStyles } from '@material-ui/core';
import { SInfiniteTable } from '@setvi/shared/components/s-table/infinite';
import { Product, RecordType } from '@setvi/shared/interfaces';

import { useSpecificationColumns } from './useSpecificationColumns';
import { useProductSpecifications } from './useProductSpecifications';

interface ProductSpecificationsProps {
  product: Product;
}

const specificationTableStyles = makeStyles(theme => ({
  tableWrapper: {
    // border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2, 0)
    // borderRadius: theme.spacing(2)
  }
}));

export const ProductSpecifications = ({
  product
}: ProductSpecificationsProps) => {
  const { specificationColumns } = useSpecificationColumns();
  const classes = specificationTableStyles();
  const { specifications } = useProductSpecifications(product);

  return specifications?.length > 0 ? (
    <Box className={classes.tableWrapper}>
      <SInfiniteTable<RecordType>
        stripped
        header={{ columns: [] }}
        list={specifications}
        keyGetter={specification => specification.label}
        columns={specificationColumns}
        tableStyle={{
          width: '100%',
          tableLayout: 'fixed'
        }}
      />
    </Box>
  ) : (
    <>-</>
  );
};
